<form-renderer [formTemplate]="formTemplate" (submit)='submitHandler()'>
</form-renderer>